import { Catalog } from "@a2ui/web_core/v0_9";

import { buildCatalogDocument } from "./buildCatalogDocument";
import {
  COMPONENT_APIS,
  REPORT_CATALOG_ID,
  reportCatalogContract
} from "./contract";

export const reportCatalog = new Catalog(REPORT_CATALOG_ID, COMPONENT_APIS);

/** What the run declares, byte-identical to the committed catalog.json. */
export const reportCatalogDocument = buildCatalogDocument(
  reportCatalogContract
);
